import React, { Component } from 'react';
import apiRequests from './api-helpers/ApiRequests';
import { Container, Row, Col, Modal, Button } from 'react-bootstrap'; // Added Modal, Button
import AddDictionaryItemSemitrailer  from './AddDictionaryItemSemitrailer';
import update from 'react-addons-update';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

class Semitrailers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            report: new Object(),
            isLoaded: false,
            pageSize: 15,
            currentPageNum: 1,
            totalPagesCount: 1,
            modalAddItemFormIsVisible: false,
            searchParams: [],
            selectedItem: new Object(), // Added for selection
            showRemoveModal: false, // Added for delete modal
        };

        this.loadSemitrailersList = this.loadSemitrailersList.bind(this);
        this.loadSemitrailersListCallback = this.loadSemitrailersListCallback.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.selectPage = this.selectPage.bind(this);
        this.onClickAddNewItem = this.onClickAddNewItem.bind(this);
        this.onChangeAddItemFormVisibility = this.onChangeAddItemFormVisibility.bind(this);
        this.addNewItemCallback = this.addNewItemCallback.bind(this);
        this.searchItems = this.searchItems.bind(this);
        this.onSelectItem = this.onSelectItem.bind(this); // Added for selection
        this.handleRemoveSemitrailerModal = this.handleRemoveSemitrailerModal.bind(this); // Added for modal
        this.removeSemitrailer = this.removeSemitrailer.bind(this); // Added for deletion
    }

    componentDidMount() {
        this.loadSemitrailersList();
    }

    loadSemitrailersList(page) {
        let setPageNum = page ? page : this.state.currentPageNum;

        let params = {
            DataInHttpResponse: true,
            SearchParams: [
                ...this.state.searchParams,
                { Name: "page", Value: setPageNum + "" },
                { Name: "size", Value: this.state.pageSize + "" },
                { Name: "ExtCompanyId", Value: this.props.userData.CompanyWorkflowId + "X" },
            ],
            ReportID: this.props.t('raportIds.semitrailers'),
        };

        apiRequests.getDataByUrlWithParam('webconapi/GetWebconReport', params, this.loadSemitrailersListCallback);
    }

    loadSemitrailersListCallback(data) {
        let pagesCount = Math.floor(data.count / this.state.pageSize) + 1;
        this.setState({
            report: data,
            isLoaded: true,
            totalPagesCount: pagesCount,
            currentPageNum: data.page,
        });
    }

    onClickAddNewItem() {
        this.onChangeAddItemFormVisibility(true);
    }

    addNewItemCallback() {
        let currentPage = 1;
        this.loadSemitrailersList(currentPage);
    }

    onChangeAddItemFormVisibility(value) {
        this.setState({ modalAddItemFormIsVisible: value });
    }

    prevPage() {
        if (this.state.currentPageNum > 1) {
            this.setState({ isLoaded: false }, () => {
                this.loadSemitrailersList(this.state.currentPageNum - 1);
            });
        }
    }

    nextPage() {
        if (this.state.currentPageNum < this.state.totalPagesCount) {
            this.setState({ isLoaded: false }, () => {
                this.loadSemitrailersList(this.state.currentPageNum + 1);
            });
        }
    }

    selectPage() { }

    searchItems(element) {
        let searchParam = { Name: element.target.name, Value: element.target.value };
        this.setState(
            prevState => {
                const idx = prevState.searchParams.findIndex(obj => obj.Name === searchParam.Name);
                if (idx === -1) {
                    return { searchParams: [...prevState.searchParams, searchParam] };
                } else {
                    return { searchParams: update(prevState.searchParams, { [idx]: { $set: searchParam } }) };
                }
            },
            () => {
                this.loadSemitrailersList(1);
            }
        );
    }

    // New: Select a semitrailer
    onSelectItem(row) {
        this.setState({ selectedItem: row });
    }

    // New: Toggle delete modal
    handleRemoveSemitrailerModal() {
        this.setState({
            showRemoveModal: !this.state.showRemoveModal,
        });
    }

    // New: Remove semitrailer
    removeSemitrailer() {
        if (this.state.selectedItem.cells) {
            let elemId = this.state.selectedItem.cells[0].value;
            console.log(this.props.userData.CompanyWorkflowId.toString());
            if (typeof elemId !== 'undefined') {
                let deleteSemitrailerParams = {
                    SemiId: parseInt(this.state.selectedItem.id),
                    RegistationNumber: "ZS546GW",
                    CompanyWorkflowId: this.props.userData.CompanyWorkflowId.toString(),
                    AccountWorkflowId: "test",
                    SemitrailerType: "test2"
                };

                apiRequests.getDataByUrlWithParam(
                    'WebconAPI/DeleteSemitrailersDictionaryItem',
                    deleteSemitrailerParams,
                    (data) => {
                        if (data.Message) {
                            this.setState(
                                { isLoaded: false, selectedItem: new Object() },
                                () => {
                                    this.loadSemitrailersList(this.state.currentPageNum);
                                }
                            );
                        }
                    }
                );
            }

            this.handleRemoveSemitrailerModal(); // Close modal
        }
    }

    render() {
        let content = !this.state.isLoaded ? (
            <Container className="m-0 p-0">
                <div className="row h-100 m-auto justify-content-center">
                    <div className="spinner-border text-primary align-self-center" role="status"></div>
                </div>
            </Container>
        ) : (
            <>
                <AddDictionaryItemSemitrailer
                    show={this.state.modalAddItemFormIsVisible}
                    onChangeAddItemFormVisibilityHandler={this.onChangeAddItemFormVisibility}
                    addNewEventNotificationCallback={this.addNewItemCallback}
                    userData={this.props.userData}
                />
                <table className="table custom-table-font">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            {this.state.report.columns.map(column => (
                                <th
                                    key={column.guid}
                                    scope="col"
                                    className={column.name === "ID" ? "d-none" : ""}
                                >
                                    {column.name}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr key="-1">
                            <th scope="row">
                                <div className="d-flex flex-column">
                                    <div className="d-flex flex-grow-1">
                                        <i className="bi bi-search"></i>
                                    </div>
                                </div>
                            </th>
                            {this.state.report.columns.map(column => {
                                let searchParamVal = this.state.searchParams.find(x => x.Name === column.name);
                                return (
                                    <td
                                        key={column.guid ? column.guid : "ColumnKey" + column.name}
                                        className={column.name === "ID" ? "d-none" : ""}
                                    >
                                        <input
                                            type="text"
                                            className="form-control fs-7"
                                            id={column.id ? column.id : "IdColumn" + column.name}
                                            name={column.name}
                                            placeholder={column.name}
                                            onChange={this.searchItems}
                                            value={searchParamVal ? searchParamVal.Value : ""}
                                        />
                                    </td>
                                );
                            })}
                        </tr>
                        {this.state.report.rows.map((row, i) => (
                            <tr
                                key={row.id}
                                onClick={() => this.onSelectItem(row)} // Updated to select item
                                className={this.state.selectedItem.id === row.id ? "selectedListItem" : ""} // Highlight selected
                            >
                                <th scope="row">{(this.state.currentPageNum - 1) * this.state.pageSize + i + 1}</th>
                                {row.cells.map((cell, j) => (
                                    <td key={row.id + "_" + j} className={j === 0 ? "d-none" : ""}>
                                        {Array.isArray(cell.value) ? cell.value[0].name : cell.value}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );

        return (
            <>
                <Modal
                    show={this.state.showRemoveModal}
                    onHide={this.handleRemoveSemitrailerModal}
                    size="sm"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.t('semitrailers.modalRemoveTitle')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.selectedItem.cells ? (
                            <>
                                <p className="mb-0">{this.props.t('semitrailers.modalLabelPlate')}</p>
                                <b className="mb-3">{this.state.selectedItem.cells[1].value}</b>
                                {/* Add more fields if needed, e.g., type or owner */}
                            </>
                        ) : (
                            ''
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={this.removeSemitrailer}>
                            {this.props.t('common.remove')}
                        </Button>
                        <Button variant="secondary" onClick={this.handleRemoveSemitrailerModal}>
                            {this.props.t('common.close')}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Container className="px-0 pt-0" fluid>
                    <div className="tables-nav">
                        <nav aria-label="Page navigation">
                            <ul className="pagination">
                                <li className="page-item">
                                    <a className="btn btn-outline-dark" onClick={this.prevPage}>
                                        <span aria-hidden="true">«</span>
                                        <span className="sr-only"></span>
                                    </a>
                                </li>
                                <li className="page-item">
                                    <a className="btn btn-outline-dark mx-1 font-weight-600">{this.state.currentPageNum}</a>
                                </li>
                                <li className="page-item">
                                    <a className="btn btn-outline-dark" onClick={this.nextPage}>
                                        <span aria-hidden="true">»</span>
                                        <span className="sr-only"></span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <button
                            type="button"
                            className="btn btn-outline-dark mx-1 font-weight-600"
                            onClick={this.onClickAddNewItem}
                        >
                            <i className="bi bi-plus-circle me-2"></i>{this.props.t('common.add')}
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-dark mx-1 font-weight-600"
                            disabled={Object.keys(this.state.selectedItem).length === 0} // Enable when selected
                            onClick={this.handleRemoveSemitrailerModal}
                        >
                            <i className="bi bi-x-circle me-2"></i>{this.props.t('common.remove')}
                        </button>
                    </div>
                    <div className="m-0 p-0">{content}</div>
                </Container>
            </>
        );
    }
}

function withMyHook(Component) {
    return function WrappedComponent(props) {
        const userData = useSelector(state => state.currentUser.userData);
        const { t } = useTranslation();
        return <Component {...props} userData={userData} t={t} />;
    };
}

export default withMyHook(Semitrailers);